import { AnyStore } from 'src/stores';

export const racesStore = new AnyStore<AnyObject[]>([]);
